import { render, staticRenderFns } from "./gradeRule.vue?vue&type=template&id=bcee4d1c&scoped=true"
import script from "./gradeRule.vue?vue&type=script&lang=ts"
export * from "./gradeRule.vue?vue&type=script&lang=ts"
import style0 from "./gradeRule.vue?vue&type=style&index=0&id=bcee4d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcee4d1c",
  null
  
)

export default component.exports